const queries = `
  query countries {
    vars {
      countries
    }
  }

  mutation CreatePerson(
    $person: PersonInputType!,
    $addresses: AddressesInputType
    $createAccount: Boolean,
    $comms: CommsPreferencesInputType
  ) {
    createPerson(
      person: $person,
      addresses: $addresses,
      createAccount: $createAccount,
      comms: $comms,
      autologin: true,
      sendWelcomeEmail: normal
    ) {
      person {
        id
      }
      login {
        jwt
        publickey
      }
    }
  }

  query AccountExists(
    $email: String!
  ) {
    accountexists(email: $email)
  }

  query getAccessToken(
    $tokentype: String
  ) {
    accesstoken( tokentype: $tokentype )
  }
`

const pageMixin = {

  data() {
    return {
      signed: null,
      countries: {}
    }
  },
  computed: {
    gqlClient() {
      return this.$store.getters.getGraphQLClient(null, queries)
    }
  },
  methods: {
    loadCountries() {
      return this.gqlClient.query({ opName: 'countries' })
        .then(response => {
          if (response.errors) {
            this.$store.dispatch('reportError',
              {
                type: 'error',
                title: 'Error processing request',
                text: 'Could not read the list of countries',
                notification: false,
                showClose: true
              }
            )
          }
          else {
            this.countries = response.data.vars.countries
          }
        }).catch(err => {
          this.$store.dispatch('reportError',
            {
              type: 'error',
              title: 'Error requesting countries',
              text: err.message,
              notification: false,
              showClose: true
            }
          )
        })
    },
    signupUser(payload) {
      return this.gqlClient.query({ opName: 'getAccessToken', variables: { tokentype: 'accountcheck' } })
        .then(response => this.gqlClient.query({
          opName: 'AccountExists',
          context: { headers: { 'X-Access-Token': response.data.accesstoken } },
          variables: { email: payload.person.email }
        }))
        .then(response => {
          if (response.errors) {
            this.$store.dispatch('reportError',
              {
                type: 'error',
                title: 'Error',
                text: response.errors[0].message,
                notification: false,
                showClose: true
              }
            )
          }
          else if (response.data.accountexists) {
            this.$store.dispatch('reportError',
              {
                type: 'error',
                title: 'Error',
                text: 'An account with this email address already exists',
                notification: false,
                showClose: true
              }
            )
          }
          else {
            return this.gqlClient.query({ opName: 'getAccessToken', variables: { tokentype: 'createperson' } })
              .then(response => this.gqlClient.mutate({
                opName: 'CreatePerson',
                context: { headers: { 'X-Access-Token': response.data.accesstoken } },
                variables: { person: payload.person, createAccount: true, comms: payload.comms, addresses: payload.addresses }
              }))
              .then(_response => {
                if (_response.errors) {
                  this.$store.dispatch('reportError',
                    {
                      type: 'error',
                      title: 'Error',
                      text: _response.errors[0].message,
                      notification: false,
                      showClose: true
                    }
                  )
                }
                else {
                  const autoLoginPayload = {
                    jwt: _response.data.createPerson.login.jwt,
                    pubkey: _response.data.createPerson.login.publickey
                  }

                  return this.$store.dispatch('user/autoLogin', autoLoginPayload, { root: true })
                    .then((status) => {
                      if (status) this.$eventHub.$emit('loginComplete')
                      this.$store.dispatch('reportError',
                        {
                          type: 'success',
                          title: 'Great!',
                          text: 'Your account has been successfully created.',
                          notification: false,
                          showClose: true,
                          timeout: 6000
                        }
                      )

                      const signupModuleSettings = this.$store.state.registry.getModuleSetting('signup') || {}
                      const redirectRoute = signupModuleSettings.hasOwnProperty('redirect')
                        ? signupModuleSettings.redirect
                        : '/'

                      this.$router.push(redirectRoute)
                    })
                }
              })
          }
        }).catch(_err => {
          this.$store.dispatch('reportError',
            {
              type: 'error',
              title: 'Error',
              text: 'Sorry. Your account could not be created.',
              notification: false,
              showClose: true
            }
          )
        })
    }
  }
}

export { pageMixin }
